import { render, staticRenderFns } from "./FavouriteSelect.vue?vue&type=template&id=b90dfc86&scoped=true&"
import script from "./FavouriteSelect.vue?vue&type=script&lang=js&"
export * from "./FavouriteSelect.vue?vue&type=script&lang=js&"
import style0 from "./FavouriteSelect.vue?vue&type=style&index=0&id=b90dfc86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90dfc86",
  null
  
)

export default component.exports